// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./styles/orders.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./styles/products.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./styles/useful-materials.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./styles/input_mask.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* orders/ */

/*================================================
input type="number" - щоб браузер не відображав стрілки додавання/віднімання
=================================================*/
input[type=number]::-webkit-outer-spin-button,
input[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type=number],
input[type=number]:hover,
input[type=number]:focus {
  appearance: none;
  -moz-appearance: textfield;
}

/* ============================================== */

.App {
  text-align: center;
}

.App-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 1.5vmin);
}

.App-link {
  color: #1D2024;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.characters {
  list-style: none;
  padding-left: 0;
}

.characters li {
  display: flex;
  align-items: center;
  border: solid 2px #d0d0d0;
  border-radius: .2em;
  padding: .5em .8em .5em .5em;
  margin-bottom: 1em;
}

.characters p {
  max-width: none;
  font-weight: bold;
  margin: 0;
}

.characters-thumb {
  overflow: hidden;
  flex-shrink: 0;
  width: 2em;
  height: 2em;
  background-color: #e8e8e8;
  padding: .5em;
  margin-right: .5em;
}

.characters-thumb img {
  display: block;
  width: 100%;
  height: auto;
}

.SortPunkt {
  margin-left: 40px;
}

.kramar-bg,
.sidebar {
  background: #fff !important;
  color: #1c1c1c;
}

.sidebar a {
  color: #000 !important;
}

a {
  color: #1D2024 !important;
}

a:hover {
  color: #6CB200 !important;
}

.btn-primary {
  --bs-btn-color: #1c1c1c !important;
  --bs-btn-hover-color: #6CB200 !important;
  --bs-btn-border-color: #1c1c1c !important;
  --bs-btn-hover-border-color: #6CB200 !important;
}

.accordion-body {
  background: #f8f9fa !important;
}

.myAllert {
  z-index: 9999999999;
  /* background-color: red; */
}

.header-brand .icon.icon-custom-size {
  display: none !important;
}

@media screen and (max-width: 767px) {
  .filter-field {
    margin-bottom: 10px;
  }
}

.accordion {
  --bs-accordion-active-color: #000 !important;
  --bs-accordion-active-bg: rgba(0, 0, 0, 0.03) !important;
  --bs-accordion-border-radius: 0 !important;
  --bs-accordion-btn-bg: rgba(0, 0, 0, 0.03) !important;
  /* --bs-accordion-btn-padding-x: 1.25rem; */
  /* --bs-accordion-btn-padding-x: 1.25rem; */
  /* --bs-accordion-btn-padding-y: 1rem; */
  --bs-accordion-btn-padding-y: 0.7rem !important;
}

.accordion-header {
  border-bottom: 1px solid rgba(0, 0, 0, 0.176) !important;
}


.accordion-body {
  background: #fff !important;
  padding: 0 !important;
}

.accordion-button:focus {
  box-shadow: none !important;
}

.popover.bs-popover-end,
.popover.bs-popover-top {
  z-index: 99999 !important;
}

.popover.bs-popover-top .popover-body {
  background-color: palegoldenrod;
}

.nav-pills .nav-link.active {
  border: 1px solid #03989e;
  background: white !important;
  border-radius: 0;
  font-weight: bold;

}

.video-container {
  position: relative;
  width: 100%;
  /* Ширина контейнера */
  height: 65px;
  /* Висота, яку ви хочете задати */
  overflow: hidden;
  /* Обрізає все, що виходить за межі контейнера */
  display: flex;
  align-items: center;
  /* Центрує відео вертикально */
  justify-content: center;
  /* Центрує відео горизонтально */
  background-color: black;
  /* Колір фону контейнера */
}

.responsive-video {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  /* Центрування відео */
  min-width: 100%;
  /* Щоб відео займало всю ширину контейнера */
  min-height: 100%;
  /* Щоб відео займало всю висоту контейнера */
  object-fit: cover;
  /* Зберігає пропорції логотипу, обрізає зайве */
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,YAAY;;AAMZ;;kDAEkD;AAClD;;EAEE,wBAAwB;AAC1B;;AAEA;;;EAIE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,mDAAmD;;AAEnD;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,yCAAyC;EACzC,+CAA+C;AACjD;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,4CAA4C;EAC5C,wDAAwD;EACxD,0CAA0C;EAC1C,qDAAqD;EACrD,2CAA2C;EAC3C,2CAA2C;EAC3C,wCAAwC;EACxC,+CAA+C;AACjD;;AAEA;EACE,wDAAwD;AAC1D;;;AAGA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;;AAEnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,iCAAiC;EACjC,gBAAgB;EAChB,gDAAgD;EAChD,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,gCAAgC;EAChC,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,sBAAsB;EACtB,eAAe;EACf,4CAA4C;EAC5C,gBAAgB;EAChB,4CAA4C;EAC5C,iBAAiB;EACjB,+CAA+C;AACjD","sourcesContent":["/* orders/ */\n@import url('styles/orders.css');\n@import url('styles/products.css');\n@import url('styles/useful-materials.css');\n@import url('styles/input_mask.css');\n\n/*================================================\ninput type=\"number\" - щоб браузер не відображав стрілки додавання/віднімання\n=================================================*/\ninput[type=number]::-webkit-outer-spin-button,\ninput[type=number]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n}\n\ninput[type=number],\ninput[type=number]:hover,\ninput[type=number]:focus {\n  -webkit-appearance: none;\n  appearance: none;\n  -moz-appearance: textfield;\n}\n\n/* ============================================== */\n\n.App {\n  text-align: center;\n}\n\n.App-header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 1.5vmin);\n}\n\n.App-link {\n  color: #1D2024;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.characters {\n  list-style: none;\n  padding-left: 0;\n}\n\n.characters li {\n  display: flex;\n  align-items: center;\n  border: solid 2px #d0d0d0;\n  border-radius: .2em;\n  padding: .5em .8em .5em .5em;\n  margin-bottom: 1em;\n}\n\n.characters p {\n  max-width: none;\n  font-weight: bold;\n  margin: 0;\n}\n\n.characters-thumb {\n  overflow: hidden;\n  flex-shrink: 0;\n  width: 2em;\n  height: 2em;\n  background-color: #e8e8e8;\n  padding: .5em;\n  margin-right: .5em;\n}\n\n.characters-thumb img {\n  display: block;\n  width: 100%;\n  height: auto;\n}\n\n.SortPunkt {\n  margin-left: 40px;\n}\n\n.kramar-bg,\n.sidebar {\n  background: #fff !important;\n  color: #1c1c1c;\n}\n\n.sidebar a {\n  color: #000 !important;\n}\n\na {\n  color: #1D2024 !important;\n}\n\na:hover {\n  color: #6CB200 !important;\n}\n\n.btn-primary {\n  --bs-btn-color: #1c1c1c !important;\n  --bs-btn-hover-color: #6CB200 !important;\n  --bs-btn-border-color: #1c1c1c !important;\n  --bs-btn-hover-border-color: #6CB200 !important;\n}\n\n.accordion-body {\n  background: #f8f9fa !important;\n}\n\n.myAllert {\n  z-index: 9999999999;\n  /* background-color: red; */\n}\n\n.header-brand .icon.icon-custom-size {\n  display: none !important;\n}\n\n@media screen and (max-width: 767px) {\n  .filter-field {\n    margin-bottom: 10px;\n  }\n}\n\n.accordion {\n  --bs-accordion-active-color: #000 !important;\n  --bs-accordion-active-bg: rgba(0, 0, 0, 0.03) !important;\n  --bs-accordion-border-radius: 0 !important;\n  --bs-accordion-btn-bg: rgba(0, 0, 0, 0.03) !important;\n  /* --bs-accordion-btn-padding-x: 1.25rem; */\n  /* --bs-accordion-btn-padding-x: 1.25rem; */\n  /* --bs-accordion-btn-padding-y: 1rem; */\n  --bs-accordion-btn-padding-y: 0.7rem !important;\n}\n\n.accordion-header {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.176) !important;\n}\n\n\n.accordion-body {\n  background: #fff !important;\n  padding: 0 !important;\n}\n\n.accordion-button:focus {\n  box-shadow: none !important;\n}\n\n.popover.bs-popover-end,\n.popover.bs-popover-top {\n  z-index: 99999 !important;\n}\n\n.popover.bs-popover-top .popover-body {\n  background-color: palegoldenrod;\n}\n\n.nav-pills .nav-link.active {\n  border: 1px solid #03989e;\n  background: white !important;\n  border-radius: 0;\n  font-weight: bold;\n\n}\n\n.video-container {\n  position: relative;\n  width: 100%;\n  /* Ширина контейнера */\n  height: 65px;\n  /* Висота, яку ви хочете задати */\n  overflow: hidden;\n  /* Обрізає все, що виходить за межі контейнера */\n  display: flex;\n  align-items: center;\n  /* Центрує відео вертикально */\n  justify-content: center;\n  /* Центрує відео горизонтально */\n  background-color: black;\n  /* Колір фону контейнера */\n}\n\n.responsive-video {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  /* Центрування відео */\n  min-width: 100%;\n  /* Щоб відео займало всю ширину контейнера */\n  min-height: 100%;\n  /* Щоб відео займало всю висоту контейнера */\n  object-fit: cover;\n  /* Зберігає пропорції логотипу, обрізає зайве */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
